module.exports = __webpack_public_path__ + "static/media/hyperopic-vision.c17a9ab0.png";